var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreathingDashboardSidebar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7096_14516",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7096_14516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11111 13.8889H7.66667V10H6.11111V13.8889ZM12.3333 13.8889H13.8889V6.11111H12.3333V13.8889ZM9.22222 13.8889H10.7778V11.5556H9.22222V13.8889ZM9.22222 10H10.7778V8.44444H9.22222V10ZM4.55556 17C4.12778 17 3.76157 16.8477 3.45694 16.5431C3.15231 16.2384 3 15.8722 3 15.4444V4.55556C3 4.12778 3.15231 3.76157 3.45694 3.45694C3.76157 3.15231 4.12778 3 4.55556 3H15.4444C15.8722 3 16.2384 3.15231 16.5431 3.45694C16.8477 3.76157 17 4.12778 17 4.55556V15.4444C17 15.8722 16.8477 16.2384 16.5431 16.5431C16.2384 16.8477 15.8722 17 15.4444 17H4.55556ZM4.55556 15.4444H15.4444V4.55556H4.55556V15.4444Z",
    fill: "#40444D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingDashboardSidebar);
export default __webpack_public_path__ + "static/media/breathing_dashboard_sidebar.c64b7640fa43a0130b5bf3ebbda5fb19.svg";
export { ForwardRef as ReactComponent };